export default "__VITE_ASSET__CDiVA5bP__"